<template>
  <div class="pr-1">
    <br />
    <div id="second-pie-chart" data-rows="rows"></div>
    <br />
    <v-divider style="margin: 0px 20px 0px 20px !important" />
    <br />
    <vue-good-table
      :columns="Columns"
      :rows="rows"
      style-class="vgt-table condensed bordered striped"
      row-style-class="tablerowheight"
      :sort-options="{
         enabled: true,
         initialSortBy: {field: 'clipDuration', type: 'desc'}
      }"
      style="padding: 0px 20px 0px 20px !important"
      class="chart-table-flocation"
    >
      <template slot="table-column" slot-scope="props">
        <span class="tablerowheight">{{props.column.label}}</span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'clipDuration'">
          <span style="text-align: center">{{changeTimeFormat(props.row.clipDuration)}}</span>
        </span>
        <span v-if="props.column.field == 'location'">
          <span style="text-align: center">{{props.row.location}}</span>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { mapState } from "vuex";
import adminSchema from "@/schemas/admin.json";
import colorValues from "values.js";
import colorScheme from "color-scheme";

am4core.useTheme(am4themes_animated);

export default {
  name: "SecondLocationsByAirTime",
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      rows: [],
      filteredRows: [],
      chartData: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      gameID: state => state.game.secondGameID,
      secondSponByGameResult: state => state.clip.secondSponByGameResult
    }),
    Columns() {
      return adminSchema.clipsPieChart.columns;
    },
    PieLabels() {
      return this.rows;
    }
  },
  watch: {
    secondSponByGameResult: {
      handler: function() {
        this.rows = this.secondSponByGameResult;
        this.rows = [];
        this.filteredRows = [];
        this.computeAirtimeByLocation();
      },
      immediate: true,
      deep: true
    },
    watchRows: {
      handler: function() {
        this.rows;
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    }
  },
  methods: {
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    //filter rows to add when locations are the same
    computeAirtimeByLocation() {
      //var v = this;

      var filteredRows = [];
      if (this.secondSponByGameResult != null) {
        this.secondSponByGameResult.forEach(function(a) {
          if (!this[a.location]) {
            this[a.location] = { location: a.location, clipDuration: 0 };
            filteredRows.push(this[a.location]);
          }
          this[a.location].clipDuration += a.clipDuration;
        }, Object.create(null));
      }

      filteredRows = this.$sortBy(filteredRows, "clipDuration");
      filteredRows = filteredRows.reverse();
      filteredRows = filteredRows.slice(0, 5);
      this.rows = filteredRows.reverse();
    },
    createChart() {
      // Create chart instance
      var chart = am4core.create("second-pie-chart", am4charts.PieChart);
      // Add data
      chart.data = this.rows; // update chart data when changing rows

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "clipDuration";
      pieSeries.dataFields.category = "location";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      /*
      var scheme = new colorScheme();
      scheme
        .from_hue(8) // Start the scheme
        .scheme("triade") // Use the 'triade' scheme, that is, colors
        // selected from 3 points equidistant around
        // the color wheel.
        .variation("soft"); // Use the 'soft' color variation

      var colorsList = scheme.colors();

     // pieSeries.colors.list = colorsList.map(function(color) {
       // return new am4core.color(color);
      //});
      // console.log(colorsList);
      pieSeries.slices.template.fill = am4core.color(colorsList[5])*/

      // Set Color acording to Theme
      /*    var colorList = [];
      new colorValues(this.portal.active.primary)
        .tints(9)
        .forEach(function(color) {
          colorList.push("#" + color.hex);
        });
      pieSeries.colors.list = colorList.map(function(color) {
        return new am4core.color(color);
      });
*/
      pieSeries.slices.template.strokeWidth = 0;

      // Add legend
      chart.legend = new am4charts.Legend();
    },
    orientationChange() {
      this.createChart();
      //console.log("Orientation changed");
    },
    resize() {
      this.createChart();
      //console.log("Page resized");
    }
  },
  beforeUpdate() {
    this.createChart();
  },
  created() {
    var v = this;
    window.addEventListener("orientationchange", v.orientationChange, false);
    window.addEventListener("resize", v.resize, false);
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    window.removeEventListener("orientationchange", this.orientationChange);
    window.removeEventListener("resize", this.resize);
  }
};
</script>


<style>
#second-pie-chart {
  width: 100%;
  height: 450px;
}

.chart-table-flocation .vgt-table.condensed td,
.vgt-table.condensed th.vgt-row-header {
  padding: 0.4em 1.4em 0.4em 0.4em !important;
  font-size: 14px !important;
}

.chart-table-flocation .vgt-table th {
  padding: 0.4em 0.2em 0.4em 0.3em !important;
}

.chart-table-flocation .tablerowheight {
  font-size: 16px !important;
}
</style>

